import { useEffect, useState } from"react";
import { Navigate, useLocation } from"react-router-dom";

const DemoGateway = ({ user, onDemoLogin }) => {
 const [status, setStatus] = useState("loading");
 const location = useLocation();

 useEffect(() => {
 if (user) {
 setStatus("ready");
 return;
 }
 onDemoLogin().then((ok) => setStatus(ok ?"ready":"error"));
 }, [user, onDemoLogin]);

 if (status ==="loading") {
 return (
 <div className="flex items-center justify-center min-h-screen bg-[#F7F9FC]">
 <div className="text-center">
 <div className="w-8 h-8 border-2 border-white/60 border-t-slate-900 rounded-full animate-spin mx-auto mb-3"/>
 <p className="text-sm text-[#94A3B8]">Loading demo...</p>
 </div>
 </div>
 );
 }

 if (status ==="error") {
 return (
 <div className="flex items-center justify-center min-h-screen bg-[#F7F9FC]">
 <p className="text-sm text-[#94A3B8]">Demo unavailable. Please try again later.</p>
 </div>
 );
 }

 const target = location.pathname.replace(/^\/demo/,"") ||"/";
 return <Navigate to={target} replace />;
};

export default DemoGateway;
